import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'

const Home = () => {
  const items = useCubeItems(PageType.HOME)

  return <CubePageTemplate items={items} showPopup />
}

export default Home
